(function () {
    'use strict';

    angular
        .module('app')
        .controller('ConcertController', ConcertController);

    ConcertController.$inject = ['$http', '$stateParams', '$rootScope', '$scope', 'authenticator', '$sce', '$state', 'dateParser', 'dialog', 'promoModule'];

    function ConcertController($http, $stateParams, $rootScope, $scope, authenticator, $sce, $state, dateParser, dialog, promoModule) {
        $rootScope.dark_text_header = false;
        var vm = this;
        vm.ticketNo = ticketNo;
        vm.$onInit = init;
        vm.backToEdit = backToEdit;
        vm.showBuyTicketHeader = false;
        vm.scrollTo = scrollTo;
        vm.copyLink = copyLink;
        vm.closeSharePopup = closeSharePopup;
        vm.filterSearch = filterSearch;
        vm.filterSearchTag = filterSearchTag;
        vm.closeCovidRequirementsPopup = closeCovidRequirementsPopup;
        vm.follow = follow;
        vm.$state = $state;
        vm.showUserProfile = [];

        document.body.onscroll = function(){
            if(!vm.showBuyTicketHeader && window.scrollY > 800) {
                vm.showBuyTicketHeader = true;
                $scope.$applyAsync();
            } else if(vm.showBuyTicketHeader && window.scrollY < 800) {
                vm.showBuyTicketHeader = false;
                $scope.$applyAsync();
            }
        };

        function init() {
            $rootScope.header_inverted = true;
            $rootScope.on_dashboard = false;
            // vm.show_banner = showBanner();
            vm.concert_slug = $stateParams.concert_slug;
            $stateParams.source_page ? vm.source_page = $stateParams.source_page : vm.source_page = "concert_link";
            vm.is_preview = $state.current.name === 'concert_preview';
            if(vm.is_preview) $rootScope.hide_header = true;

            vm.buyTicketNo = 1;

            getConcert();
            getLoggedIn();


            $scope.$on('$destroy', function(){
                $rootScope.hide_header = false;
            });
        }

        function follow(type) {
            if (!vm.logged_in) {
                var backState = angular.copy($stateParams);
                return $state.go('login', { 'backToStateName': 'concert', 'backToStateParams': backState });
            }
            if(type == 'space') {
                if(vm.space.following) {
                    dialog.prompt('unfollow-profile-prompt', function (response) {
                        if (response.confirm) {
                            $http.post('api/follow/space/' + vm.space.space_slug);
                            vm.space.following = !vm.space.following;
                        }
                    }, false, true);
                } else {
                    $http.post('api/follow/space/' + vm.space.space_slug);
                    vm.space.following = !vm.space.following;
                }
            } else if (type == 'band') {
                if(vm.band.following) {
                    dialog.prompt('unfollow-profile-prompt', function (response) {
                        if (response.confirm) {
                            $http.post('api/follow/band/' + vm.band.band_slug);
                            vm.band.following = !vm.band.following;
                        }
                    }, false, true);
                } else {
                    $http.post('api/follow/band/' + vm.band.band_slug);
                    vm.band.following = !vm.band.following;
                }
            }

        }

        function filterSearch(genre) {
            $state.go('concerts', {'genre': genre.filter_value_name});
        }

        function filterSearchTag(tag) {
            $state.go('concerts', {'tag': tag.tag_id});
        }

        function backToEdit(){
            $state.go("edit_concert", {'concert_slug': vm.concert_slug, 'back_from_preview_or_save': true});
        }

        function ticketNo() {
            return new Array(vm.concert.remaining_tickets);
        }

        function getLoggedIn() {
            authenticator.checkLoginStatus()
                .then(function (isLoggedIn) {
                    vm.logged_in = isLoggedIn;
                });

        }

        function getTicketRequests(){
            return $http.get('api/concerts/'+vm.concert.concert_slug+'/ticket_requests/')
                .then(function(response){
                    vm.tickets = response.data;
                });
        }

        function getConcert() { //Get data about the concert with the concert-API
            return $http.get('api/concerts/' + $stateParams.concert_slug + '/')
                .then(function (response) {
                    vm.concert = response.data;
                    vm.concert_link = response.data.concert_link;
                    vm.concert_link_da = response.data.concert_link_da;
                    if($stateParams.language == 'da'){
                        vm.mailto_link = "mailto:" + "" +
                                    "?subject=" + vm.concert.concert_name + " - Be My Concert" +
                                    "&body=" + vm.concert_link_da;
                    } else if ($stateParams.language == 'en') {
                        vm.mailto_link = "mailto:" + "" +
                                    "?subject=" + vm.concert.concert_name + " - Be My Concert" +
                                    "&body=" + vm.concert_link;
                    }


                    if (vm.concert.concert_deleted_at > '') {
                        return $state.go('item_deleted');
                    }

                    vm.concert.concert_start_time = dateParser.parseDate(vm.concert.concert_start_time);
                    vm.concert.concert_end_time = dateParser.parseDate(vm.concert.concert_end_time);
                    vm.concert.concert_door_time = dateParser.parseDate(vm.concert.concert_door_time);

                    vm.concert.split_description = splitTextByLineBreak(vm.concert.concert_description_short);

                    window.document.title = vm.concert.concert_name + " - " +  moment(vm.concert.concert_start_time).format('DD.MM.YY') + " - Be My Concert";
                    document.getElementsByTagName('meta')["title"].content = window.document.title;

                    getBand(vm.concert.band.band_slug);
                    if (vm.concert.space.space_slug) {
                        getSpace(vm.concert.space.space_slug);
                    }
                    if (vm.concert.concert_video) { //Gets the youtube URL, creates a youtube-embed URL and trusts it
                        var p = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
                        vm.yt_stripped = ((vm.concert.concert_video.match(p)) ? RegExp.$1 : false);
                        vm.yt_url = $sce.trustAsResourceUrl('https://www.youtube.com/embed/' + vm.yt_stripped);
                    }
                    getTicketRequests();
                    vm.concertJsonId = {
                            "@type": "MusicEvent",
                            "name": vm.concert.concert_name,
                            "location": {
                                "type": "Place",
                                "name": vm.concert.space_name,
                                "address": {
                                    "@type":"PostalAddress",
                                    "addressLocality": vm.concert.concert_city,
                                    "addressCountry": vm.concert.concert_country
                                    }
                                },
                            "offers": {
                                "name": vm.concert.concert_name,
                                "url": "https://bemyconcert.com/concert/" + vm.concert.concert_slug,
                                "description": vm.concert.concert_description_short,
                                "price": vm.concert.concert_price,
                                "priceCurrency": vm.concert.concert_currency,
                                "availability": "https://schema.org/InStock",
                                "validFrom": moment(vm.concert.concert_published).format('YYYY-MM-DD')
                                },
                            "startDate": moment(vm.concert.concert_start_time).format('YYYY-MM-DD'),
                            "endDate": moment(vm.concert.concert_end_time).format('YYYY-MM-DD'),
                            "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
                            "eventStatus": "https://schema.org/EventScheduled",
                            "url": "https://bemyconcert.com/concert/" + vm.concert.concert_slug,
                            "performer": [
                                {
                                    "@type": "MusicGroup",
                                    "name": vm.concert.band.band_name,
                                    "sameAs": "https://bemyconcert.com/musician/" + vm.concert.band.band_slug
                                }
                            ],
                            "description": vm.concert.concert_description_short,
                            "organizer": {
                                "name": vm.concert.space.space_name,
                                "url": "https://bemyconcert.com/host/" + vm.concert.space.space_slug
                            },
                            "image": {
                                "@type": "ImageObject",
                                "url": "https://bemyconcert.com/uploads/bands/" + vm.concert.band.band_slug + "/" + vm.concert.band_image_hash + "_xl.jpeg"
                            },
                            "logo": {
                                "@type": "ImageObject",
                                "url": "https://bemyconcert.com/uploads/bands/" + vm.concert.band.band_slug + "/" + vm.concert.band_image_hash + "_xs.jpeg"
                            }
                        };
                    promoModule.createAllBanners(vm.concert);
                });
        }

        function getBand(band_slug) { //Gets data about the band playing at the concert
            return $http.get('api/bands/' + band_slug + '/')
                .then(function (response) {
                    vm.band = response.data;
                });
        }

        function splitTextByLineBreak(text){
            var match = /\r|\n/.exec(text);

            return match ? [text.substr(0, match.index), text.substr(match.index)] : [text, ''];
        }

        function getSpace(space_slug) { //Gets data about the space where the concert is held
            return $http.get('api/spaces/' + space_slug + '/')
                .then(function (response) {
                    vm.space = response.data;
                });
        }

        function showBanner(){
            $http.get('api/site_setting/1/is_active/')
            .then(function (response) {
                vm.show_banner = response.data.is_active;
            })
        }

        function scrollTo(elementID, time, where) {
            var e = document.getElementById(elementID);
            var eTop = e.getBoundingClientRect().top -100;
            var eAmt = eTop / 100;
            var curTime = 0;
            while (curTime <= time) {
                window.setTimeout(SVS_B, curTime, eAmt, where);
                curTime += time / 100;
            }
        }

        function SVS_B(eAmt, where) {
            if(where == "center" || where == "")
                window.scrollBy(0, eAmt / 2);
            if (where == "top")
                window.scrollBy(0, eAmt);
        }

        function copyLink(){
            navigator.clipboard.writeText(vm.concert_link);
            vm.link_copied = 1;
        }

        function closeSharePopup(){
            vm.link_copied = 0;
            vm.show_share_popup = 0;
        }

        function closeCovidRequirementsPopup(){
            vm.show_covid_requirements_pop_up = 0;
        }
    }
})();
